import './TagButton.scss';
import Component from './TagButton.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
